import { Injectable } from '@angular/core';
import * as contentful from 'contentful';
import {environment} from '../environments/environment';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { from } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class ContentfulService {
  total_count!: number;
  accessTokenKeyfirst :string  = 'I4AAVh7bSQNN4HBxQ2Oi';
  accessTokenKeysecond :string  = 'dOd3PvkzgqFGW9w2n0eI7pE';

  private client = contentful.createClient({
    space: 'vvg0tv7wf1gv',
    accessToken : this.accessTokenKeyfirst + this.accessTokenKeysecond
	});

	constructor(
	) {
  }
  getIntriesCount(){
	  return this.total_count;
  }
  //console logs a response for debugging
	logContent(contentId:any){
		this.client.getEntry(contentId)
		.then((entry) => console.log())
	}
	getContent(contentId:any,userLang:any){
		const promise = this.client.getEntry(contentId,{
			locale: userLang
		});
		return from(promise).pipe(map(entry => entry.fields));
	}

  getEntries(userLang:any){
  const promise = this.client.getEntries({
        locale: userLang,
        limit:1000
    });
    return from(promise).pipe(map(entries => entries));
	}
}
